import "./instrument";
import "./i18n";
import { reactErrorHandler } from "@sentry/react";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import LayoutSkeleton from "./components/LayoutSkeleton";
import "./index.css";

const root = createRoot(document.getElementById("root")!, {
  onUncaughtError: (...args) => {
    console.error("[Uncaught React Error]", ...args);
    reactErrorHandler()(...args);
  },
  onCaughtError: (...args) => {
    console.error("[Caught React Error]", ...args);
    reactErrorHandler()(...args);
  },
  onRecoverableError: (...args) => {
    console.error("[Recoverable React Error]", ...args);
    reactErrorHandler()(...args);
  },
});

root.render(
  <StrictMode>
    <Suspense fallback={<LayoutSkeleton />}>
      <App />
    </Suspense>
  </StrictMode>,
);
